module.exports = __webpack_public_path__ + "static/media/icon_security_old.e376b4b1.svg";